"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    methods: {
        getCategoryName(categoryId) {
            switch (categoryId) {
                case '20':
                    return '野球';
                case '30':
                    return 'サッカー';
                case '40':
                    return 'その他スポーツ';
                case '45':
                    return 'ゲーム';
                case '50':
                    return 'エンタメ';
                case '60':
                    return '政治・経済';
                case '70':
                    return 'その他';
                default:
                    return '総合';
            }
        },
        formatDate(date) {
            const y = date.getFullYear();
            const m = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
            const d = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
            return `${y}-${m}-${d}`;
        },
        formatTime(date) {
            const h = date.getHours() < 10 ? `0${date.getHours()}` : `${date.getHours()}`;
            const m = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
            return `${h}:${m}`;
        },
        formatPeriod(fromDate, toDate) {
            if (!fromDate)
                return '';
            const fromMonth = fromDate.getMonth() + 1;
            const fromDay = fromDate.getDate();
            const fromWeekday = '日月火水木金土'.charAt(fromDate.getDay());
            const fromHour = fromDate.getHours();
            const toDay = toDate.getDate();
            const toWeekday = '日月火水木金土'.charAt(toDate.getDay());
            const toHour = toDate.getHours();
            return `${fromMonth}月${fromDay}日 (${fromWeekday}) ${fromHour}時～${toDay}日 (${toWeekday}) ${toHour}時`;
        },
        getRemaining(date) {
            let remaining;
            const remainingMillis = date.getTime() - Date.now();
            if (remainingMillis < 0) {
                remaining = '0分';
            }
            else if (remainingMillis < 1000 * 60) {
                remaining = '1分未満';
            }
            else if (remainingMillis < 1000 * 60 * 60) {
                remaining = Math.floor(remainingMillis / 1000 / 60) + '分';
            }
            else if (remainingMillis < 1000 * 60 * 60 * 24) {
                remaining = Math.floor(remainingMillis / 1000 / 60 / 60) + '時間';
            }
            else {
                remaining = Math.floor(remainingMillis / 1000 / 60 / 60 / 24) + '日';
            }
            return `${remaining}`;
        },
        getPassed(date) {
            let passed;
            const passedMillis = Date.now() - date.getTime();
            if (passedMillis < 0) {
                passed = '0分';
            }
            else if (passedMillis < 1000 * 60) {
                passed = '1分以内';
            }
            else if (passedMillis < 1000 * 60 * 60) {
                passed = Math.floor(passedMillis / 1000 / 60) + '分前';
            }
            else if (passedMillis < 1000 * 60 * 60 * 24) {
                passed = Math.floor(passedMillis / 1000 / 60 / 60) + '時間前';
            }
            else if (passedMillis < 1000 * 60 * 60 * 24 * 30) {
                passed = Math.floor(passedMillis / 1000 / 60 / 60 / 24) + '日前';
            }
            else if (passedMillis < 1000 * 60 * 60 * 24 * 30 * 365) {
                passed = Math.floor(passedMillis / 1000 / 60 / 60 / 24 / 30) + 'ヶ月前';
            }
            else {
                passed = Math.floor(passedMillis / 1000 / 60 / 60 / 24 / 30 / 365) + '年前';
            }
            return `${passed}`;
        },
        bigram(str) {
            const result = {};
            for (let i = 1; i < str.length; i++) {
                if (str[i - 1] !== ' ' && str[i] !== ' ') {
                    result[(str[i - 1] + str[i]).toString()] = true;
                }
            }
            return result;
        },
        logJSON(logLevel, message) {
            return JSON.stringify({
                severity: logLevel,
                message: message,
            });
        }
    },
    data() {
        return {
            userConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        nickname: data.nickname,
                        message: data.message,
                        avatarUrl: data.avatar_url,
                        lastLoginAt: data.last_login_at ? data.last_login_at.toDate() : undefined,
                        bonusReceivedAt: data.bonus_received_at ? data.bonus_received_at.toDate() : undefined,
                        lastViewAt: data.last_view_at ? data.last_view_at.toDate() : undefined,
                        answerCount: data.answer_count,
                    };
                }
            },
            followConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        userId: data.user_id,
                        followerId: data.follower_id,
                    };
                }
            },
            categoryConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        categoryName: data.label,
                    };
                }
            },
            predictionConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        createdAt: data.created_at ? data.created_at.toDate() : undefined,
                        updatedAt: data.updated_at ? data.updated_at.toDate() : undefined,
                        creatorId: data.creator_id,
                        categoryId: data.category_id,
                        categoryName: null,
                        categoryIcon: null,
                        predictionTitle: data.prediction_title,
                        predictionBody: data.prediction_body,
                        openAt: data.open_at ? data.open_at.toDate() : undefined,
                        closeAt: data.close_at ? data.close_at.toDate() : undefined,
                        reportingFrom: data.reporting_from ? data.reporting_from.toDate() : undefined,
                        reportingTo: data.reporting_to ? data.reporting_to.toDate() : undefined,
                        creatorRewardRate: data.creator_reward_rate,
                        reporterRewardRate: data.reporter_reward_rate,
                        isPublished: data.is_published,
                        secondReportingFrom: data.second_reporting_from ? data.second_reporting_from.toDate() : undefined,
                        secondReportingTo: data.second_reporting_to ? data.second_reporting_to.toDate() : undefined,
                        answerCount: data.answer_count,
                        commentCount: data.comment_count,
                        correctChoiceNo: data.correct_choice_no,
                        isFinalized: data.is_finalized,
                        finalizedAt: data.finalized_at ? data.finalized_at.toDate() : undefined,
                        creatorRewardAmount: data.creator_reward_amount,
                        isInvalid: data.is_invalid,
                        invalidReasonCd: data.invalid_reason_cd,
                        link1: data.link1,
                        link2: data.link2,
                        link3: data.link3,
                        imagePath: data.image_path,
                        index: data.index,
                        bad: data.bad,
                    };
                }
            },
            choiceConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        choice: data.choice,
                        answerCount: data.answer_count,
                        odds: data.odds,
                        reportCount: data.report_count,
                        secondReportCount: data.second_report_count,
                    };
                }
            },
            goodForPredictionConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        predictionId: data.prediction_id,
                        userId: data.user_id,
                    };
                }
            },
            watchListConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        userId: data.user_id,
                        predictionId: data.prediction_id,
                    };
                }
            },
            answerConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        answerAt: data.answer_at ? data.answer_at.toDate() : undefined,
                        userId: data.user_id,
                        predictionId: data.prediction_id,
                        categoryId: data.category_id,
                        closeAt: data.close_at ? data.close_at.toDate() : undefined,
                        choiceNo: data.choice_no,
                        answerAmount: data.answer_amount,
                        isFinalized: data.is_finalized,
                        rewardAmount: data.reward_amount,
                    };
                }
            },
            commentsConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        createdAt: data.created_at ? data.created_at.toDate() : undefined,
                        updatedAt: data.updated_at ? data.updated_at.toDate() : undefined,
                        userId: data.user_id,
                        content: data.content,
                        like: data.like,
                        replyCount: data.reply_count ? data.reply_count : 0,
                        bad: data.bad,
                    };
                }
            },
            replyConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        createdAt: data.created_at ? data.created_at.toDate() : undefined,
                        updatedAt: data.updated_at ? data.updated_at.toDate() : undefined,
                        userId: data.user_id,
                        content: data.content,
                        like: data.like,
                        bad: data.bad,
                    };
                }
            },
            goodForCommentConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        commentId: data.comment_id,
                        userId: data.user_id,
                    };
                }
            },
            reportConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        reportType: data.report_type,
                        reportAt: data.report_at ? data.report_at.toDate() : undefined,
                        reporterId: data.reporter_id,
                        predictionId: data.prediction_id,
                        categoryId: data.category_id,
                        reportingTo: data.reporting_to ? data.reporting_to.toDate() : undefined,
                        secondReportingTo: data.second_reporting_to ? data.second_reporting_to.toDate() : undefined,
                        choiceNo: data.choice_no,
                        isOpposed: data.is_opposed,
                        isFinalized: data.is_finalized,
                        rewardAmount: data.reward_amount,
                    };
                }
            },
            rankConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        rankType: data.rank_type,
                        categoryId: data.category_id,
                        userId: data.user_id,
                        rank: data.rank,
                        ratioType: data.ratio_type,
                        correctCount: data.correct_count,
                        answerCount: data.answer_count,
                        tipAmount: data.tip_amount,
                        acquiredPoint: data.acquired_point,
                        usedPoint: data.used_point,
                    };
                }
            },
            recordConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        userId: data.user_id,
                        categoryId: data.category_id,
                        createCount: data.create_count,
                        finalizedCount: data.finalized_count,
                        creatorRewardAmount: data.creator_reward_amount,
                        reportingCount: data.reporting_count,
                        correctCount: data.correctCount,
                        reporterRewardAmount: data.reporter_reward_amount,
                        truthPoint: data.truth_point,
                    };
                }
            },
            notificationConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        userId: data.user_id,
                        createdAt: data.created_at.toDate(),
                        title: data.title,
                        content: data.content,
                    };
                }
            },
            summaryConverter: {
                toFirestore() { return {}; }, // 使用しない
                fromFirestore(snapshot) {
                    if (!snapshot.exists)
                        return {};
                    const data = snapshot.data();
                    return {
                        id: snapshot.id,
                        prediction: data.prediction,
                        choice: data.choice,
                        comments: data.comments,
                        reply: data.reply,
                        answer: data.answer,
                        report: data.report,
                        rank: data.rank,
                        notification: data.notification,
                        users: data.users,
                        receipts: data.receipts,
                        createdAt: data.created_at.toDate(),
                    };
                }
            },
            reportType: {
                // 結果投票
                reporting: 1,
                // 再投票
                secondReporting: 2,
            },
            rankType: {
                // チップランキング
                tipRanking: 1,
                // デイリーランキング
                dailyRanking: 2,
                // 週間ランキング
                weeklyRanking: 3,
                // 月間ランキング
                monthlyRanking: 4,
                // イベントランキング
                eventRanking: 5,
            },
            ratioType: {
                // 上昇
                up: 1,
                // 横ばい
                same: 2,
                // 下降
                down: 3,
            },
            invalidCode: {
                // 投票数不足
                lessReports: 10,
                // 正解が複数
                multipleCorrectAnswer: 11,
                // 予想数不足
                lessAnswers: 12,
                // 過去の予想
                oldPrediction: 13,
                // 異議申し立て成立
                opposed: 14,
                // 公序良俗に反する
                inappropriate: 15,
                // 公平性に欠ける
                unfair: 16,
                // 正解が明確でない
                unclear: 17,
                // 予想になっていない
                notPrediction: 18,
                // 出題者による
                creator: 19,
                // その他
                other: 20,
            },
            excludeUserList: [
                '0x9da5d673091576a7cfd7fd5204b28d2dc8378929', // 通りすがり
                'FbKhXB1QKwUVcJCGA7BlSAvQaL53', // ゲストユーザーアカウント
                '02DuGeifbUZ9jfFYojp5OoT616j2', // AppStore審査用に用意したアカウント
                '0Q9aDINanbZHIpVGJoNTvegVXMo1', // 多分、AppStore審査者のアカウント
                'Q0tPNvlXXISFjK2ymY7dr1Q1CZJ2', // 多分、AppStore審査者のアカウント
                'yXvxXWjgHbU7PzEdKrY4FAdQIGs2', // AppStore審査者のアカウント（レシートあり）
                'XdhbCxWUKKRSJsjvxkKSA3epiKp1', // 多分、AppStore審査者のアカウント
                'xIdivsAzFARyTNwkzXANdsG38hk2', // 多分、AppStore審査者のアカウント
            ]
        };
    }
};
//# sourceMappingURL=mixin.js.map